import { Modal, message, notification } from 'antd';

export const confirm = (props, texts = {}) => {
  let args;
  if (typeof (props) === 'function') {
    args = { ...texts, onOk: props };
  } else {
    args = { ...texts, ...props };
  }
  Modal.confirm(args);
};

export const confirmDelete = (props) => {
  confirm(props, {
    title: 'Bạn có chắc chắn muốn xóa?',
    okText: 'Xóa',
    cancelText: 'Bỏ qua',
  });
};

export const confirmIgnoreChange = (props) => {
  confirm(props, {
    title: 'Bạn muốn bỏ qua các sửa đổi và đóng cửa sổ?',
    okText: 'Bỏ qua',
    cancelText: 'Tiếp tục',
  });
};

const defaultMessages = {
  success: 'Thành công!',
  warning: 'Thông báo!',
  error: 'Lỗi!',
};

function notify(props, type = 'info', simple = true) {
  let args = {};
  if (typeof (props) === 'string') {
    args.message = props;
  } else {
    args = {
      message: defaultMessages[type],
      ...props,
    };
  }
  if (!args.duration) {
    args.duration = 1.5;
    if (type === 'error') args.duration = 3.0;
    else if (type === 'warning') args.duration = 2.0;
    else if (type === 'success') args.duration = 1.5;
  }
  if (simple) {
    message[type](args.message, args.duration);
  } else {
    notification[type](args);
  }
}

export const notifySuccess = (props) => {
  notify(props, 'success');
};

export const notifyError = (props) => {
  notify(props, 'error');
};

export const notifyWarning = (props) => {
  notify(props, 'warning');
};

export default {
  notify,
};



// WEBPACK FOOTER //
// ./src/utils/notify.js